import { useEffect, useState } from "react";
import { _Entailment } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { _BodyComponent, _HealthAttentionCause, _HealthAttentionGateEntry, _HealthAttentionModality, _HealthAttentionService, _HealthAttentionSite, _HealthLOINC, _HealthLOINCIMP, _HealthProduct, _HealthRegimen, _HealthTechnologyType, _TriageType } from "../../../../core/services/dataBean/EntityCatalogVdos";
import usePaginator from "../../../theme/Component/usePaginator";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { FileInput } from "../../../theme/Component/FileInput";




export const HealthLOINC = () => {

    const loinc = useDataBean(_HealthLOINC);
    const imp = useDataBean(_HealthLOINCIMP);
    const single = Singleton.getInstance();
    const paginador = usePaginator();
    const [regexStr, setregexStr] = useState<any>(null)
    const [type, setType] = useState<any>(null)
    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalimp, setModalimp] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {

        loinc.instance.getHealthLOINCCatalog(regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    setLista(resp.List)
                }
            }
        )

    }

    const create = () => {
        loinc.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        loinc.deleteItemVoid(loinc.bean.IDHealthLOINC).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        loinc.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const verimp = () => {
        setModalimp({ ...modalimp, "view": true });

    }
    const head = [
        { title: 'ID', property: 'IDHealthLOINC', visible: true },
        { title: 'LOINC', property: 'LOINC_NUM', visible: true },
        { title: 'Nombre Común', property: 'LONG_COMMON_NAME', visible: true },
        { title: 'Nombre Corto', property: 'SHORTNAME', visible: true },
        { title: 'Componente', property: 'COMPONENT', visible: true },
        { title: 'Propiedad', property: 'PROPERTY', visible: true },
        { title: 'Tiempo', property: 'TIME_ASPCT', visible: true },
        { title: 'Sistema', property: 'SYSTEM', visible: true },
        { title: 'Escala', property: 'SCALE_TYP', visible: true },
        { title: 'Método', property: 'METHOD_TYP', visible: true },
        { title: 'Clase', property: 'CLASS', visible: true },
        { title: 'Tipo', property: 'CHNG_TYPE', visible: true },
        { title: 'Ejemplo Unidades UCUM', property: 'EXAMPLE_UCUM_UNITS', visible: true },
        { title: 'Orden/Observaciones', property: 'ORDER_OBS', visible: true },
        { title: 'Primera Versión', property: 'VersionFirstReleased', visible: true },
        { title: 'Última Versión', property: 'VersionLastChanged', visible: true },
        { title: 'Ranking', property: 'COMMON_TEST_RANK', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${loinc.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const importHealthLOINCCatalog = () => {
        //console.log(entailment.bean);
        imp.instance.importHealthLOINCCatalog(imp.bean.Media, imp.bean.MediaContext, null).then(
            (resp: any) => {
                console.log(resp)
                setModalimp({ ...modalimp, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    return (
        <BasicPage titulo="Catálogo LOINC - Standard Internacional de Test y Observaciones">
            <div className="row">
                <div className="col-md-4">
                    <label>Búsqueda por Texto</label>
                    <input type="text" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                </div>
                <div className="col-md-2 mt-4 p-2">
                    <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-wallet-2-fill" eventClick={verimp}>Importar Catálogo LOINC (Archivo Loinc.csv de https://loinc.org)</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={loinc.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-6">
                                <label>LOINC</label>
                                <input type="text" name="LOINC_NUM" className="form-control" value={loinc.bean.LOINC_NUM} onChange={(e: any) => { loinc.setBean({ ...loinc.bean, 'LOINC_NUM': e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Nombre Común</label>
                                <input type="text" name="LONG_COMMON_NAME" className="form-control" value={loinc.bean.LONG_COMMON_NAME} onChange={loinc.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Nombre Corto</label>
                                <input type="text" name="SHORTNAME" className="form-control" value={loinc.bean.SHORTNAME} onChange={loinc.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Componente</label>
                                <input type="text" name="COMPONENT" className="form-control" value={loinc.bean.COMPONENT} onChange={loinc.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Propiedad</label>
                                <input type="text" name="PROPERTY" className="form-control" value={loinc.bean.PROPERTY} onChange={loinc.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Tiempo</label>
                                <input type="text" name="TIME_ASPCT" className="form-control" value={loinc.bean.TIME_ASPCT} onChange={loinc.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Sistema</label>
                                <input type="text" name="SYSTEM" className="form-control" value={loinc.bean.SYSTEM} onChange={loinc.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Escala</label>
                                <input type="text" name="SCALE_TYP" className="form-control" value={loinc.bean.SCALE_TYP} onChange={loinc.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Método</label>
                                <input type="text" name="METHOD_TYP" className="form-control" value={loinc.bean.METHOD_TYP} onChange={loinc.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Clase</label>
                                <input type="text" name="CLASS" className="form-control" value={loinc.bean.CLASS} onChange={loinc.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Tipo</label>
                                <input type="text" name="CHNG_TYPE" className="form-control" value={loinc.bean.CHNG_TYPE} onChange={loinc.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Ejemplo Unidades UCUM</label>
                                <input type="text" name="EXAMPLE_UCUM_UNITS" className="form-control" value={loinc.bean.EXAMPLE_UCUM_UNITS} onChange={loinc.handleChange} />
                            </div>

                            <div className="col-md-6">
                                <label>Primera Versión</label>
                                <input type="text" name="VersionFirstReleased" className="form-control" value={loinc.bean.VersionFirstReleased} onChange={loinc.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Última Versión</label>
                                <input type="text" name="VersionLastChanged" className="form-control" value={loinc.bean.VersionLastChanged} onChange={loinc.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Ranking</label>
                                <input type="text" name="COMMON_TEST_RANK" className="form-control" value={loinc.bean.COMMON_TEST_RANK} onChange={loinc.handleChange} />
                            </div>
                            <div className="col-md-12">
                                <label>Orden / Observaciones</label>
                                <textarea name="ORDER_OBS" className="form-control" value={loinc.bean.ORDER_OBS} onChange={loinc.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalimp} updateModal={setModalimp} eventModal={importHealthLOINCCatalog}>
                        <div className="row">
                            <div className="col-md-12">

                                <FileInput
                                    Media={imp.bean.Media}
                                    MediaContext={imp.bean.MediaContext}
                                    directory='temp'
                                    label='Archivo'
                                    onCreate={(Filemap: any) => { imp.setBean({ ...imp.bean, "Media": Filemap.Media, "MediaContext": Filemap.MediaContext }); }}
                                ></FileInput>
                            </div>

                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {loinc.bean.Name}</strong>
                    </ModalConfirm>
                </div>
            </div>
        </BasicPage>
    )
}